import { app_mst_link_login_subject_to_tenant_RowClass } from "../../dbschema";
import { BaseContainerModel } from "../base-container.model";

export class LoginTenantLinksContainerModel extends BaseContainerModel {
    app_mst_link_login_subject_to_tenant: app_mst_link_login_subject_to_tenant_RowClass = new app_mst_link_login_subject_to_tenant_RowClass();
}